import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as OrganizationActions from './organization.actions';
import { OrganizationInterfaceWithId } from '@sk/sk-interfaces';


export const ORGANIZATION_FEATURE_KEY = 'organization';

export interface OrganizationState extends EntityState<OrganizationInterfaceWithId> {
  currentOrganizationId: string | undefined; // which Organization record has been selected
  currentOrganization: OrganizationInterfaceWithId | undefined; // which Organization record has been selected
  currentOrganizationLoaded: boolean; // has the Clients list been loaded
  organizationLoadError?: string | null; // last none error (if any)
  organizationIdLoadError?: string | null; // last none error (if any)
  firestoreOrganizationError?: string | null; // last none error when adding a new client (if any)

  updateOrganizationError?: string | null // last known error when updating current organization (if any)
  updateOrganizationSuccess: boolean;  // has the update action been successful
}

export interface OrganizationPartialState {
  readonly [ORGANIZATION_FEATURE_KEY]: OrganizationState;
}

export const organizationAdapter: EntityAdapter<OrganizationInterfaceWithId> = createEntityAdapter<OrganizationInterfaceWithId>({
  selectId: selectOrganizationId
});

export const initialState: OrganizationState = organizationAdapter.getInitialState({
  // set initial required properties
  currentOrganizationId: undefined,
  currentOrganization: undefined,
  currentOrganizationLoaded: false,
  updateOrganizationSuccess: false
});


export function selectOrganizationId(a: OrganizationInterfaceWithId): string {
  //In this case this would be optional since primary key is id
  return a.id;
}


const organizationReducer = createReducer(
  initialState,


  /**
   * CurrentOrganizationId
   */

  on(OrganizationActions.setCurrentOrganizationId, (state, { organizationId }) => {
    if (state.organizationIdLoadError) {
      delete state.organizationIdLoadError;
      delete state.updateOrganizationError;
    }
    return ({
      ...state,
      currentOrganizationId: organizationId
    });
  }),

  on(OrganizationActions.setCurrentOrganizationIdSuccess, (state, {}) => {
    if (state.organizationIdLoadError) {
      delete state.organizationIdLoadError;
      delete state.updateOrganizationError;
    }
    return ({
      ...state,
      currentOrganizationIdLoaded: true
    });
  }),

  /**
   * UPDATE ORGANIZATION ACTIONS
   */

  on(OrganizationActions.updateOrganization, (state, { id, changes }) => {
    if (state.updateOrganizationError) {
      delete state.updateOrganizationError;
    }
    return organizationAdapter.updateOne({
        id,
        changes
      },
      {
        ...state,
        updateOrganizationSuccess: false
      });
  }),

  on(OrganizationActions.updateOrganization, (state, {}) => {
    if (state.updateOrganizationError) {
      delete state.updateOrganizationError;
    }
    return {
      ...state,
      updateOrganizationSuccess: true
    };
  }),

  on(OrganizationActions.updateOrganizationError, (state, { error }) => {
    return ({
      ...state,
      updateOrganizationError: error.message
    });
  }),


  /**
   * ACTION FROM FireStore
   */
  on(OrganizationActions.fromFireStoreAddOrganization, (state, { organization }) => {
    if (state.firestoreOrganizationError) {
      delete state.firestoreOrganizationError;
    }
    return organizationAdapter.setOne(organization, {
      ...state,
      currentOrganization: organization
    });
  }),


  on(OrganizationActions.getFireStoreOrganizationError, (state, {
    error
  }) => {
    return {
      ...state,
      currentOrganization: null,
      firestoreOrganizationError: error.message
    };
  })
);


export function reducer(state: OrganizationState | undefined, action: Action) {
  return organizationReducer(state, action);
}
